function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6256 5.01052C14.428 3.2081 17.3138 3.17157 19.0711 4.92893C20.8285 6.68629 20.792 9.57206 18.9896 11.3745L10.5587 19.8054C9.20685 21.1572 7.04252 21.1846 5.7245 19.8666C4.40648 18.5485 4.43388 16.3842 5.78569 15.0324L13.5367 7.28142C14.3628 6.45531 15.6854 6.43857 16.4909 7.24402C17.2963 8.04948 17.2796 9.37212 16.4535 10.1982L9.24644 17.4053C8.94603 17.7057 8.46507 17.7118 8.17218 17.4189C7.87928 17.126 7.88537 16.645 8.18578 16.3446L15.3928 9.13757C15.6181 8.91227 15.6227 8.55155 15.403 8.33188C15.1834 8.11221 14.8226 8.11678 14.5973 8.34208L6.84635 16.0931C6.09534 16.8441 6.08012 18.0465 6.81236 18.7787C7.54459 19.5109 8.74699 19.4957 9.498 18.7447L17.9289 10.3138C19.1305 9.11221 19.1549 7.18836 17.9833 6.01679C16.8117 4.84521 14.8879 4.86956 13.6863 6.07118L5.79929 13.9581C5.49889 14.2585 5.01793 14.2646 4.72503 13.9717C4.43214 13.6788 4.43823 13.1979 4.73863 12.8975L12.6256 5.01052Z",
  fill: "#555770"
});

function SvgUploaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaded);
export default __webpack_public_path__ + "static/media/uploaded.3dc2d471.svg";
export { ForwardRef as ReactComponent };